import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import css from "../../css/agents/filter-collapse.module.css";

const FilterCollapse = (props) => {
    const [collapsed, setCollapsed] = useState(false);

    useEffect(() => {
        if (props.onCollapse) {
            props.onCollapse(collapsed);
        }
    }, [collapsed]);

    const toggle = () => {
        setCollapsed(!collapsed);
    };

    const { title, children } = props;
    const btnClassName = collapsed ? css.buttonUp : css.buttonDown;
    const contentClassName = collapsed ? css.contentCollapsed : css.content;

    return (
        <div className={css.collapse}>
            <div className={css.header}>
                <div className={css.title}>
                    <a href="#" onClick={toggle}>
                        {title}
                    </a>
                </div>
                <div className={css.control}>
                    <a
                        href="#"
                        className={btnClassName}
                        onClick={toggle}
                        role="button"
                        aria-label={title}
                    />
                </div>
            </div>
            <div className={contentClassName}>{children}</div>
        </div>
    );
};

FilterCollapse.propTypes = {
    title: PropTypes.string.isRequired,
    onCollapse: PropTypes.func,
};

export default FilterCollapse;
